import type { HanCoinSoundSources } from "#han-coin-sound-sources";

/** The web shell plays no deposit sounds: it has no drawer button for coins to land in. */
export function getHanCoinSoundSources(): HanCoinSoundSources | null {
  return null;
}
